import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { PROJECTS, IMAGES } from "../data/site";

const FIELDS = [
    ["Industry", "industry"],
    ["Equipment Supplied", "equipment"],
    ["Scope", "scope"],
    ["Location", "location"],
    ["Year", "year"],
];

const Projects = () => (
    <div data-testid="projects-page">
        <PageHero
            kicker="PROJECTS"
            title="Engineering"
            accent="Delivered"
            sub="A selection of furnace, heating and automation projects. Detailed project references are shared on request."
            image={IMAGES.factory}
            crumb="Projects"
        />
        <section className="bg-brand-mist py-20 md:py-24 technical-grid-light">
            <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                    {PROJECTS.map((p, i) => (
                        <Reveal key={p.title} delay={Math.min(i * 0.08, 0.3)}>
                            <article className="group flex h-full flex-col bg-white shadow-[0_2px_20px_rgba(15,18,22,0.05)] transition-shadow duration-300 hover:shadow-[0_16px_44px_rgba(15,18,22,0.14)]" data-testid={`project-card-${i}`}>
                                <div className="relative h-52 overflow-hidden">
                                    <img src={p.image} alt={`${p.title} project`} loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                    <span className="absolute bottom-0 left-0 bg-brand-ink px-4 py-2 font-mono text-[10px] tracking-[0.2em] text-brand-ember uppercase">
                                        {p.industry}
                                    </span>
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <h2 className="font-display text-lg font-bold uppercase leading-tight text-brand-charcoal">{p.title}</h2>
                                    <dl className="mt-5 flex-1 space-y-2.5">
                                        {FIELDS.map(([label, key]) => (
                                            <div key={key} className="flex gap-3 text-xs">
                                                <dt className="w-32 shrink-0 font-semibold uppercase tracking-wide text-slate-400">{label}</dt>
                                                <dd className="text-slate-600">{p[key]}</dd>
                                            </div>
                                        ))}
                                    </dl>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2}>
                    <div className="mt-16 bg-brand-ink p-8 text-center md:p-14 grain relative overflow-hidden">
                        <div className="technical-grid absolute inset-0" />
                        <div className="relative">
                            <Kicker light><span className="mx-auto">YOUR PROJECT NEXT</span></Kicker>
                            <p className="mx-auto mt-4 max-w-xl font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-white">
                                Want a similar solution for your process?
                            </p>
                            <Link to="/get-a-quote" data-testid="projects-quote-cta"
                                className="group mt-8 inline-flex items-center gap-3 bg-brand-red px-8 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-ember">
                                REQUEST A QUOTE <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                            </Link>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Projects;
